(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function initCountdowns(root) {
      root.querySelectorAll('.prestige-countdown').forEach(function (cd) {
        var end = new Date(cd.dataset.end).getTime();
        var timer = cd.querySelector('.prestige-countdown__timer');
        if (isNaN(end) || !timer) { if (timer) timer.style.display = 'none'; return; }
        var d = timer.querySelector('[data-d]'), h = timer.querySelector('[data-h]'),
            m = timer.querySelector('[data-m]'), s = timer.querySelector('[data-s]');
        function tick() {
          var diff = end - Date.now();
          if (diff <= 0) {
            var msg = timer.getAttribute('data-expired');
            timer.innerHTML = msg ? '<span class="prestige-countdown__label">' + msg + '</span>' : '';
            clearInterval(cd._t);
            return;
          }
          var dd = Math.floor(diff / 86400000);
          var hh = Math.floor(diff % 86400000 / 3600000);
          var mm = Math.floor(diff % 3600000 / 60000);
          var ss = Math.floor(diff % 60000 / 1000);
          if (d) d.textContent = pad(dd); if (h) h.textContent = pad(hh);
          if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
        }
        tick();
        cd._t = setInterval(tick, 1000);
      });
    }

    function initBar(root) {
      if (!root) return;
      initCountdowns(root);
      var items = Array.prototype.slice.call(root.querySelectorAll('.prestige-announcement__item'));
      if (items.length <= 1) return;
      var i = 0, timer = null;
      var auto = root.dataset.autorotate === 'true';
      var speed = parseInt(root.dataset.speed, 10) || 5000;
      var prev = root.querySelector('.ann-prev'), next = root.querySelector('.ann-next');

      function show(n) {
        i = (n % items.length + items.length) % items.length;
        items.forEach(function (it, idx) { it.classList.toggle('is-active', idx === i); });
      }
      function start() { stop(); if (auto) timer = setInterval(function () { show(i + 1); }, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (next) next.addEventListener('click', function () { show(i + 1); start(); });
      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
      root._capAnn = { show: show, start: start, stop: stop };
    }

    function boot() {
      document.querySelectorAll('.prestige-announcement').forEach(initBar);
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);

    document.addEventListener('shopify:section:load', function (e) {
      var el = document.getElementById('prestige-announcement-' + e.detail.sectionId);
      if (el) initBar(el);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('.prestige-announcement');
      if (root && root._capAnn) { root._capAnn.stop(); root._capAnn.show(parseInt(e.target.dataset.index, 10) || 0); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('.prestige-announcement');
      if (root && root._capAnn) root._capAnn.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var chips = root.querySelectorAll('.prestige-cg__chip');
      chips.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) { chips.forEach(function (o) { if (o !== d) o.open = false; }); }
        });
      });
      document.addEventListener('click', function (e) {
        chips.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
      });
    }
    document.querySelectorAll('.prestige-cg').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) {
      var el = document.getElementById('prestige-cg-' + e.detail.sectionId);
      if (el) boot(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n){ return n<10 ? '0'+n : ''+n; }
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var t = root.querySelector('.prestige-cd__timer'); if (!t) return;
      var end = new Date(t.dataset.end).getTime();
      if (isNaN(end)) { t.style.display = 'none'; return; }
      var d=t.querySelector('[data-d]'),h=t.querySelector('[data-h]'),m=t.querySelector('[data-m]'),s=t.querySelector('[data-s]');
      function tick(){
        var diff = end - Date.now();
        if (diff <= 0) { var msg=t.dataset.expired; t.innerHTML = msg ? '<p style="margin:0;font-size:20px;">'+msg+'</p>' : ''; clearInterval(t._i); return; }
        if(d)d.textContent=pad(Math.floor(diff/86400000)); if(h)h.textContent=pad(Math.floor(diff%86400000/3600000));
        if(m)m.textContent=pad(Math.floor(diff%3600000/60000)); if(s)s.textContent=pad(Math.floor(diff%60000/1000));
      }
      tick(); t._i = setInterval(tick, 1000);
    }
    function boot(){ document.querySelectorAll('.prestige-cd').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el=document.getElementById('prestige-cd-'+e.detail.sectionId); if(el){ el.dataset.inited=''; init(el);} });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function init(root) {
      if (!root || root.dataset.inited === '1') return;
      root.dataset.inited = '1';

      // ---- Mobile drawer ----
      var burger = root.querySelector('.prestige-burger');
      var drawer = root.querySelector('.prestige-drawer');
      var overlay = root.querySelector('.prestige-drawer-overlay');
      var closeBtn = root.querySelector('.prestige-drawer__close');
      function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); overlay.hidden = false; drawer.setAttribute('aria-hidden', 'false'); if (burger) burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
      function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); overlay.hidden = true; drawer.setAttribute('aria-hidden', 'true'); if (burger) burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
      if (burger) burger.addEventListener('click', openDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      root.querySelectorAll('.prestige-drawer__toggle').forEach(function (t) {
        t.addEventListener('click', function () {
          var item = t.closest('.prestige-drawer__item');
          var open = item.classList.toggle('is-open');
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      // ---- Desktop dropdown (touch / keyboard) ----
      root.querySelectorAll('.prestige-nav__item.has-children > .prestige-nav__link').forEach(function (lnk) {
        lnk.addEventListener('click', function (e) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            var item = lnk.closest('.prestige-nav__item');
            if (!item.classList.contains('is-open')) { e.preventDefault(); }
            root.querySelectorAll('.prestige-nav__item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
            item.classList.toggle('is-open');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.prestige-nav__item')) {
          root.querySelectorAll('.prestige-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        }
      });

      // ---- Search ----
      var sToggles = root.querySelectorAll('.prestige-search-toggle');
      var search = root.querySelector('.prestige-search');
      var sInput = root.querySelector('.prestige-search__input');
      var sClose = root.querySelector('.prestige-search__close');
      var sResults = root.querySelector('.prestige-search__results');
      function openSearch() { if (!search) return; search.hidden = false; if (sInput) sInput.focus(); }
      function closeSearch() { if (!search) return; search.hidden = true; if (sResults) { sResults.hidden = true; sResults.innerHTML = ''; } }
      sToggles.forEach(function (b) { b.addEventListener('click', function () { search && search.hidden ? openSearch() : closeSearch(); }); });
      if (sClose) sClose.addEventListener('click', closeSearch);

      if (sInput && root.dataset.enablePredictive === 'true') {
        var base = root.dataset.predictive || '/search/suggest';
        var t;
        sInput.addEventListener('input', function () {
          clearTimeout(t);
          var q = sInput.value.trim();
          if (q.length < 2) { sResults.hidden = true; sResults.innerHTML = ''; return; }
          t = setTimeout(function () {
            fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
              .then(function (r) { return r.json(); })
              .then(function (data) {
                var items = (((data || {}).resources || {}).results || {}).products || [];
                if (!items.length) { sResults.hidden = true; sResults.innerHTML = ''; return; }
                sResults.innerHTML = items.map(function (p) {
                  var img = p.image || (p.featured_image && p.featured_image.url) || '';
                  var price = p.price ? '<span class="prestige-search__result-price">' + p.price + '</span>' : '';
                  return '<a class="prestige-search__result" href="' + p.url + '">' +
                    (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                    '<span class="prestige-search__result-title">' + p.title + '</span>' + price + '</a>';
                }).join('');
                sResults.hidden = false;
              }).catch(function () { sResults.hidden = true; });
          }, 250);
        });
      }

      // ---- ESC closes everything ----
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });

      // ---- Transparent → solid on scroll ----
      if (root.dataset.transparent === 'true') {
        var onScroll = function () { root.classList.toggle('is-scrolled', window.scrollY > 60); };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      // ---- Live cart count ----
      var countEl = root.querySelector('[data-cart-count]');
      function refreshCart() {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          if (!countEl) return;
          countEl.textContent = c.item_count;
          countEl.classList.toggle('is-empty', c.item_count === 0);
        }).catch(function () {});
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
      window.addEventListener('pageshow', refreshCart);
    }

    function boot() { document.querySelectorAll('.prestige-header').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) {
      var el = document.getElementById('prestige-header-' + e.detail.sectionId);
      if (el) { el.dataset.inited = ''; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-image-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var spots = root.querySelectorAll('.prestige-hs__spot');
      spots.forEach(function (sp) {
        var dot = sp.querySelector('.prestige-hs__dot');
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = sp.classList.contains('is-open');
          root.querySelectorAll('.prestige-hs__spot.is-open').forEach(function (o) { o.classList.remove('is-open'); });
          if (!open) sp.classList.add('is-open');
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.prestige-hs__stage')) root.querySelectorAll('.prestige-hs__spot.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      });
    }
    function boot() { document.querySelectorAll('.prestige-hs').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-hs-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setMain(img, url) {
      if (!img || !url) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    }
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var dataEl = root.querySelector('[data-prestige-variants]');
      var mainImg = root.querySelector('[data-main-image]');
      // Thumbs
      var thumbs = root.querySelectorAll('.prestige-mp__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          setMain(mainImg, t.dataset.thumb);
          thumbs.forEach(function (o) { o.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = root.querySelectorAll('[data-option-index]');
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var addBtn = root.querySelector('[data-add]');
      var addText = root.querySelector('[data-add-text]');
      if (!selects.length) return;

      function current() { return Array.prototype.map.call(selects, function (s) { return s.value; }); }
      function update() {
        var chosen = current();
        var v = variants.find(function (vr) { return vr.options.length === chosen.length && vr.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          var html = (v.compare ? '<s>' + v.compare + '</s> ' : '') + '<span data-current>' + v.price + '</span>';
          priceEl.innerHTML = html;
        }
        if (addBtn) { addBtn.disabled = !v.available; }
        if (addText) { addText.textContent = v.available ? (addText.dataset.label || 'Agregar al carrito') : 'Agotado'; }
        if (v.img) setMain(mainImg, v.img);
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });

      // Swatches (opción de color/tela): al hacer clic, fijan el select oculto y disparan el update.
      var swBtns = root.querySelectorAll('.prestige-mp__sw');
      swBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-swatch-index');
          var sel = root.querySelector('select[data-option-index="' + idx + '"]');
          if (sel) { sel.value = btn.getAttribute('data-value'); sel.dispatchEvent(new Event('change')); }
          root.querySelectorAll('.prestige-mp__sw[data-swatch-index="' + idx + '"]').forEach(function (o) { o.classList.remove('is-sel'); });
          btn.classList.add('is-sel');
          var valEl = root.querySelector('[data-opt-val="' + idx + '"]');
          if (valEl) { var dv = btn.getAttribute('data-value').split(' '); dv.shift(); valEl.textContent = dv.join(' '); }
        });
      });
    }
    function boot() { document.querySelectorAll('.prestige-mp').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-mp-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      if (root.querySelector('.prestige-rec__inner')) return;
      var url = root.dataset.url; if (!url || url.indexOf('product_id=') === -1) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.prestige-rec__inner');
        if (inner) root.appendChild(inner);
      }).catch(function () {});
    }
    function boot() { document.querySelectorAll('.prestige-rec').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-rec-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-promo-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var box = root.querySelector('.prestige-pop__box');
      if (box && root.querySelector('.prestige-pop__media')) box.classList.add('has-media');
      var key = 'prestige_pop_' + root.dataset.sectionId;
      var days = parseInt(root.dataset.days, 10) || 0;
      var design = (window.Shopify && window.Shopify.designMode);

      function dismissed() {
        if (design) return false;
        try { var v = localStorage.getItem(key); if (!v) return false; if (!days) return true; return (Date.now() - parseInt(v,10)) < days*86400000; } catch(e){ return false; }
      }
      function open() { root.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { root.hidden = true; document.body.style.overflow = ''; try { localStorage.setItem(key, Date.now().toString()); } catch(e){} }

      root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

      if (design) { open(); return; }
      if (dismissed()) return;
      setTimeout(open, parseInt(root.dataset.delay, 10) || 3000);
    }
    function boot() { document.querySelectorAll('.prestige-pop').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-pop-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'prestige_recently_viewed';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var cur = null;
      var curEl = root.querySelector('[data-prestige-current]');
      if (curEl) { try { cur = JSON.parse(curEl.textContent); } catch (e) {} }
      var list = read();
      if (cur && cur.url) {
        list = list.filter(function (p) { return p.url !== cur.url; });
        list.unshift(cur);
        if (list.length > 12) list = list.slice(0, 12);
        write(list);
      }
      var show = list.filter(function (p) { return !cur || p.url !== cur.url; }).slice(0, parseInt(root.dataset.limit, 10) || 4);
      if (!show.length) { root.hidden = true; return; }
      var grid = root.querySelector('[data-grid]');
      grid.innerHTML = show.map(function (p) {
        return '<a class="prestige-rv__card" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '<span class="prestige-rv__name">' + p.title + '</span><span class="prestige-rv__price">' + (p.price || '') + '</span></a>';
      }).join('');
      root.hidden = false;
    }
    function boot() { document.querySelectorAll('.prestige-rv').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-rv-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function init(root) {
      if (!root || root.dataset.inited === '1') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.prestige-slide'));
      if (!slides.length) return;
      root.dataset.inited = '1';

      var dots = Array.prototype.slice.call(root.querySelectorAll('.prestige-dot'));
      var prev = root.querySelector('.prestige-slideshow__arrow--prev');
      var next = root.querySelector('.prestige-slideshow__arrow--next');
      var i = 0, timer = null;
      var auto = root.dataset.autorotate === 'true';
      var speed = parseInt(root.dataset.speed, 10) || 6000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function videoOf(slide) { return slide ? slide.querySelector('video') : null; }

      function syncMedia(n) {
        slides.forEach(function (s, idx) {
          var v = videoOf(s);
          if (!v) return;
          if (idx === n) {
            try { v.muted = true; v.currentTime = 0; } catch (e) {}
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            try { v.pause(); v.currentTime = 0; } catch (e) {}
          }
        });
      }

      /* Todas las diapositivas duran lo mismo, incluidas las de video.
         El video arranca desde 0 en cada vuelta y se corta al cumplirse
         el tiempo de «Cambiar cada». */
      function durationFor(n) {
        return speed;
      }

      function show(n) {
        n = (n % slides.length + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.remove('is-active', 'is-prev');
          if (idx === n) s.classList.add('is-active');
          else if (idx === i) s.classList.add('is-prev');
        });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === n); });
        i = n;
        syncMedia(n);
      }
      function start() {
        stop();
        if (auto && !reduce && slides.length > 1) {
          timer = setTimeout(function () { show(i + 1); start(); }, durationFor(i));
        }
      }
      function stop() { if (timer) { clearTimeout(timer); timer = null; } }

      show(0);
      if (next) next.addEventListener('click', function () { show(i + 1); start(); });
      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.goto, 10) || 0); start(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); start(); }
        x0 = null;
      });

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(i + 1); start(); }
        if (e.key === 'ArrowLeft') { show(i - 1); start(); }
      });

      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      start();
      root._prestige = { show: show, start: start, stop: stop };
    }

    function boot() {
      Array.prototype.slice.call(document.querySelectorAll('.prestige-slideshow')).forEach(init);
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);

    document.addEventListener('shopify:section:load', function (e) {
      var el = document.getElementById('prestige-slideshow-' + e.detail.sectionId);
      if (el) { el.dataset.inited = ''; init(el); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('.prestige-slideshow');
      if (root && root._prestige) { root._prestige.stop(); root._prestige.show(parseInt(e.target.dataset.index, 10) || 0); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('.prestige-slideshow');
      if (root && root._prestige) root._prestige.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prestige-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
      var cover = root.querySelector('.prestige-vid__cover');
      if (!cover) return;
      cover.addEventListener('click', function () {
        var src = cover.getAttribute('data-embed');
        var ifr = document.createElement('iframe');
        ifr.setAttribute('src', src);
        ifr.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
        ifr.setAttribute('allowfullscreen', '');
        cover.parentNode.replaceChild(ifr, cover);
      });
    }
    function boot() { document.querySelectorAll('.prestige-vid').forEach(init); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { var el = document.getElementById('prestige-vid-' + e.detail.sectionId); if (el) { el.dataset.inited=''; init(el); } });
  })();

  } catch(e) { console.error(e); }
})();
})();
